module.exports = __webpack_public_path__ + "img/zacros.54ed8a4a.jpg";